module.exports = __webpack_public_path__ + "static/img/build02.2a948c70.png";